module.exports = __webpack_public_path__ + "img/6.0e617503.jpg";